<span class="mat-optgroup-label" role="presentation" [id]="_labelId">{{ label }} <ng-content></ng-content></span>
<ng-content select="mat-option, ng-container"></ng-content>
